import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Código", -1)
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Título", -1)
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-label fw-medium" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Asignatura", -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Saber", -1)
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Año académico", -1)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Peso (%)", -1)
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Descripción", -1)
const _hoisted_18 = { class: "col-md-3 d-flex align-items-center mt-2" }
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, "Cancelar", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_form, {
      ref: "formRecord",
      id: "formModal",
      onSubmit: _withModifiers(_ctx.save, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_b_form_input, {
              modelValue: _ctx.form.record.DisplayCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.DisplayCode) = $event)),
              size: "sm",
              placeholder: "Código interno"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_b_form_input, {
              modelValue: _ctx.form.record.Title,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.Title) = $event)),
              size: "sm",
              placeholder: "Título de la competencia",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, "Docente " + _toDisplayString(_ctx.form.record.TeacherId), 1),
            _createVNode(_component_SearchSelect, {
              modelValue: _ctx.form.record.TeacherId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record.TeacherId) = $event)),
              loading: _ctx.loading,
              options: _ctx.teachers
                        .map((s) => ({
                            value: s.Id,
                            text: `${s.IdentificationNumber} - ${s.Name} ${s.LastName}`
                        })),
              placeholder: "Seleccione un docente"
            }, null, 8, ["modelValue", "loading", "options"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_SearchSelect, {
              modelValue: _ctx.form.record.SubjectId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.SubjectId) = $event)),
              loading: _ctx.loading,
              options: _ctx.subjects.map(r => ({
                        value: r.Id,
                        text: `${r.Code} - ${r.Name}`,
                    })),
              placeholder: "Seleccione la asignatura"
            }, null, 8, ["modelValue", "loading", "options"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_SearchSelect, {
              modelValue: _ctx.form.record.SaberTypeId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.SaberTypeId) = $event)),
              loading: _ctx.loading,
              options: _ctx.saberTypes.filter(f => f.EnableCompetencies).map(r => ({
                        value: r.Id,
                        text: `${r.Code} - ${r.Name}`,
                    })),
              placeholder: "Seleccione el tipo de saber"
            }, null, 8, ["modelValue", "loading", "options"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_SearchSelect, {
              modelValue: _ctx.form.record.AcademicYearId,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.record.AcademicYearId) = $event)),
              loading: _ctx.loading,
              options: _ctx.academicYears.map(r => ({
                        value: r.Id,
                        text: `Año ${r.Year} - Período: ${r.StartDate.substring(0, 10)} Hasta ${r.EndDate.substring(0, 10)}`,
                    })),
              placeholder: "Seleccione el año académico"
            }, null, 8, ["modelValue", "loading", "options"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_b_form_input, {
              modelValue: _ctx.form.record.WeightPercent,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.record.WeightPercent) = $event)),
              modelModifiers: { number: true },
              type: "number",
              min: "0",
              max: "100",
              size: "sm",
              placeholder: "0 - 100"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_b_form_textarea, {
              modelValue: _ctx.form.record.Description,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.record.Description) = $event)),
              rows: "3",
              size: "sm",
              placeholder: "Descripción de la competencia"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_b_form_checkbox, {
              modelValue: _ctx.form.record.Enable,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.record.Enable) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Habilitada ")
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_b_button, {
                class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.form.record.Id ? 'Guardar cambios' : 'Agregar competencia'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_b_button, {
                onClick: _ctx.cancel,
                class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
              }, {
                default: _withCtx(() => [
                  _hoisted_21,
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}